(function(account, $, undefined)
{
    account.init = function()
    {
        this.cacheInitialized = [];
        this.sections = {
            'index' : 'uiIndex',
            'reset' : 'uiReset',
	        'new-game-plus' : 'uiNewGamePlus',
	        'recall-forbidden-ninjas' : 'uiRecallForbiddenNinjas',
            'change-name' : 'uiChangeName',
            'change-password' : 'uiChangePassword',
	        'recover-password' : 'uiRecoverPassword',
	        'recover-password-change' : 'uiRecoverPasswordChange',
	        'resend-activation' : 'uiResendActivation',
	        'connect-nm1' : 'uiConnectNm1',
	        'settings' : 'uiSettings',
            'avatar' : 'uiAvatar',
            'background' : 'uiBackground',
            'login' : 'uiLogin',
            'register' : 'uiRegister'
        };

        main.loadPageEvents(jsData['subPage']);

        this.uiEvents();

        main.setStartingPushState();
    };

    account.uiEvents = function()
    {

    };

    account.uiIndex = function()
    {

    };

    account.uiRegister = function()
    {
        $('#register-nm-button').on('click', clickRegisterSubmit);


        function clickRegisterSubmit(e)
        {
            e.preventDefault();

            var sendData = $('#register-nm-form').serialize();

            main.showLoader('spin');

            $.ajaxHandler({
                url: '/ajax/registerAccount',
                type: 'POST',
                data: sendData,
                dataType: 'json',
                cache: false
            }).done(function(data)
            {
                main.hideLoader();

                main.showMessageBox(data['text'], 'html');
            });

            return false;
        }
    };

    account.uiLogin = function()
    {
        $('#login-nm-button').on('click', clickLoginSubmit);


        function clickLoginSubmit(e)
        {
            e.preventDefault();

            var sendData = $('#login-nm-form').serialize();

            main.showLoader('spin');

            $.ajaxHandler({
                url: '/account/login/nm',
                type: 'POST',
                data: sendData,
                dataType: 'json',
                cache: false
            }).done(function(data)
            {
                main.hideLoader();

                main.showMessageBox(data['text'], 'html');

                setTimeout(function() {
                    location.href = '/';
                }, 2000);
            });

            return false;
        }
    };

    account.uiAvatar = function()
    {
        var $_avatarNinjas = $('#account-avatars');

        $('#change-avatar').on('click', clickChangeAvatarButton);
        $_avatarNinjas.on('click', '.c-card', selectAvatar);


        function selectAvatar()
        {
            $_avatarNinjas.find('.-c-sel').removeClass('-c-sel');
            $(this).addClass('-c-sel');
        }

        function clickChangeAvatarButton()
        {
            var sendData = {
                'Avatar' : $_avatarNinjas.find('.-c-sel').data('ninjaid'),
	            'Alternate' : $_avatarNinjas.find('.-c-sel').data('alternate')
            };

            main.showLoader('spin');

            $.ajaxHandler({
                url: '/ajax/changeAvatar',
                type: 'POST',
                data: sendData,
                dataType: 'json',
                cache: false
            }).done(function(data)
            {
                main.hideLoader();

                main.showMessageBox(data['text'], 'html');
            });
        }
    };

    account.uiBackground = function()
    {
        var $_backgrounds = $('#account-backgrounds');

        $('#change-background').on('click', clickChangeBackgroundButton);
        $_backgrounds.on('click', '.c-area-box', selectBackground);


        function selectBackground()
        {
            $_backgrounds.find('.-c-sel').removeClass('-c-sel');
            $(this).addClass('-c-sel');
        }

        function clickChangeBackgroundButton()
        {
            var sendData = {
                'Background' : $_backgrounds.find('.-c-sel').data('background')
            };

            main.showLoader('spin');

            $.ajaxHandler({
                url: '/ajax/changeBackground',
                type: 'POST',
                data: sendData,
                dataType: 'json',
                cache: false
            }).done(function(data)
            {
                main.hideLoader();

                main.showMessageBox(data['text'], 'html');
            });
        }
    };

    account.uiChangeName = function()
    {
        $('#change-teamname').on('click', clickChangeTeamNameButton);
        $('#change-username').on('click', clickChangeUsernameButton);


        function clickChangeUsernameButton()
        {
            if ($(this).hasClass('-color-cancel'))
                return false;

            var sendData = {
                'Username' : $('#input-username').val()
            };

            main.showLoader('spin');

            $.ajaxHandler({
                url: '/ajax/changeUsername',
                type: 'POST',
                data: sendData,
                dataType: 'json',
                cache: false
            }).done(function(data)
            {
                main.hideLoader();

                main.showMessageBox(data['text'], 'html');
            });
        }

        function clickChangeTeamNameButton()
        {
            if ($(this).hasClass('-color-cancel'))
                return false;

            var sendData = {
                'TeamName' : $('#input-teamname').val()
            };

            main.showLoader('spin');

            $.ajaxHandler({
                url: '/ajax/changeTeamName',
                type: 'POST',
                data: sendData,
                dataType: 'json',
                cache: false
            }).done(function(data)
            {
                main.hideLoader();

                main.showMessageBox(data['text'], 'html');
            });
        }
    };

	account.uiChangePassword = function()
	{
		$('#change-password').on('click', clickChangePasswordButton);


		function clickChangePasswordButton()
		{
			if ($(this).hasClass('-color-cancel'))
				return false;

			var sendData = {
				'PasswordCur' : $('#input-password').val(),
				'PasswordNew' : $('#input-password-new').val(),
				'PasswordNewAgain' : $('#input-password-new-again').val()
			};

			main.showLoader('spin');

			$.ajaxHandler({
				url: '/ajax/changePassword',
				type: 'POST',
				data: sendData,
				dataType: 'json',
				cache: false
			}).done(function(data)
			{
				main.hideLoader();

				main.showMessageBox(data['text'], 'html');
			});
		}
	};

	account.uiRecoverPassword = function()
	{
		$('#recover-password').on('click', clickRecoverPasswordButton);


		function clickRecoverPasswordButton()
		{
			if ($(this).hasClass('grey'))
				return false;

			var sendData = {
				'User' : $('#input-recover-password').val()
			};

			main.showLoader('spin');

			$.ajaxHandler({
				url: '/ajax/recoverPassword',
				type: 'POST',
				data: sendData,
				dataType: 'json',
				cache: false
			}).done(function(data)
			{
				main.hideLoader();

				main.showMessageBox(data['text'], 'html');
			});
		}
	};

	account.uiRecoverPasswordChange = function()
	{
		$('#change-password').on('click', clickChangePasswordButton);


		function clickChangePasswordButton()
		{
			if ($(this).hasClass('grey'))
				return false;

			var sendData = {
				'Token' : $('#input-token').val(),
				'PasswordNew' : $('#input-password-new').val(),
				'PasswordNewAgain' : $('#input-password-new-again').val()
			};

			main.showLoader('spin');

			$.ajaxHandler({
				url: '/ajax/recoverPasswordChange',
				type: 'POST',
				data: sendData,
				dataType: 'json',
				cache: false
			}).done(function(data)
			{
				main.hideLoader();

				main.showMessageBox(data['text'], 'html');
			});
		}
	};

    account.uiReset = function()
    {
        $('#reset-team').on('click', clickResetButton);
	    $('#kage-resign').on('click', clickResignKageButton);
	    $('#kage-forfeit-challenger').on('click', clickForfeitChallengerButton);

	    function clickResignKageButton()
	    {
		    main.showLoader('spin');

		    $.ajaxHandler({
			    url: '/ajax/resignKagePosition',
			    type: 'POST',
			    dataType: 'json',
			    cache: false
		    }).done(function(data)
		    {
			    main.hideLoader();

			    main.showMessageBox(data['text'], 'html');
		    });
	    }

	    function clickForfeitChallengerButton()
	    {
		    main.showLoader('spin');

		    $.ajaxHandler({
			    url: '/ajax/forfeitChallengerPosition',
			    type: 'POST',
			    dataType: 'json',
			    cache: false
		    }).done(function(data)
		    {
			    main.hideLoader();

			    main.showMessageBox(data['text'], 'html');
		    });
	    }

        function clickResetButton()
        {
	        if ($(this).hasClass('-color-cancel'))
		        return false;

            var lws = $('.js-reset-lw').map(function() {
                return this.value
            }).get();

	        var bloodlines = $('.js-reset-bloodlines').map(function() {
		        return this.value
	        }).get();

            var sendData = {
                'LWs' : lws,
	            'Bloodlines' : bloodlines
            };

	        var messageData = {
		        'Text' : $.i18n._('confirmation_reset')
	        };

	        main.showMessageBox(messageData).then(function(answer)
	        {
		        main.hideLoader();

		        if ((String(answer) != 'true'))
			        return false;

		        main.showLoader('spin');

		        $.ajaxHandler({
			        url: '/ajax/resetTeam',
			        type: 'POST',
			        data: sendData,
			        dataType: 'json',
			        cache: false
		        }).done(function(data)
		        {
			        main.hideLoader();

			        main.showMessageBox(data['text'], 'html');

			        $('#reset-team').removeAttr('id').addClass('-color-cancel').removeClass('-color-yes');
		        });
	        });
        }
    };

	account.uiRecallForbiddenNinjas = function()
	{
		$('#recall').on('click', clickRecallButton);
		$('#recall-forbidden-ninjas').find('.c-card').on('click', clickForbiddenNinjaCard);

		function clickRecallButton()
		{
			if ($(this).hasClass('-color-cancel'))
				return false;

			var sendData = {
				'NinjaID' : $('.js-forbidden-ninjas .c-card.-c-sel').data('ninjaid')
			};

			main.showLoader('spin');
			
		    $.ajaxHandler({
			    url: '/ajax/recallForbiddenNinja',
			    type: 'POST',
				data: sendData,
			    dataType: 'json',
			    cache: false
		    }).done(function(data)
		    {
			    main.hideLoader();

			    main.showMessageBox(data['text'], 'html');

				$('#recall').removeAttr('id').addClass('-color-cancel').removeClass('-color-yes');
		    });
		}

		function clickForbiddenNinjaCard()
        {
            var $_this = $(this);

	        $('#recall-forbidden-ninjas').find('.-c-sel').removeClass('-c-sel');
	        $_this.addClass('-c-sel');
	        $('#recall').addClass('-color-yes').removeClass('-color-cancel');
        }
	};

	account.uiNewGamePlus = function()
	{
		$('#rebirth-team').on('click', clickRebirthButton);
		$('#kage-resign').on('click', clickResignKageButton);
		$('#kage-forfeit-challenger').on('click', clickForfeitChallengerButton);

		function clickResignKageButton()
		{
			main.showLoader('spin');

			$.ajaxHandler({
				url: '/ajax/resignKagePosition',
				type: 'POST',
				dataType: 'json',
				cache: false
			}).done(function(data)
			{
				main.hideLoader();

				main.showMessageBox(data['text'], 'html');
			});
		}

		function clickForfeitChallengerButton()
		{
			main.showLoader('spin');

			$.ajaxHandler({
				url: '/ajax/forfeitChallengerPosition',
				type: 'POST',
				dataType: 'json',
				cache: false
			}).done(function(data)
			{
				main.hideLoader();

				main.showMessageBox(data['text'], 'html');
			});
		}

		function clickRebirthButton()
		{
			if ($(this).hasClass('-color-cancel'))
				return false;

			var lws = $('.js-rebirth-lw').map(function() {
				return this.value
			}).get();

			var bloodlines = $('.js-rebirth-bloodlines').map(function() {
				return this.value
			}).get();

			var bloodlineGenjutsus = $('.js-rebirth-bloodline-genjutsus').map(function() {
				return this.value
			}).get();

			var gift = $('.js-rebirth-gift').val();

			var sendData = {
				'Gift' : gift,
				'LWs' : lws,
				'Bloodlines' : bloodlines,
				'BloodlineGenjutsus' : bloodlineGenjutsus
			};

			var messageData = {
				'Text' : $.i18n._('confirmation_reset')
			};

			main.showMessageBox(messageData).then(function(answer)
			{
				main.hideLoader();

				if ((String(answer) != 'true'))
					return false;

				main.showLoader('spin');

				$.ajaxHandler({
					url: '/ajax/rebirthTeam',
					type: 'POST',
					data: sendData,
					dataType: 'json',
					cache: false
				}).done(function(data)
				{
					main.hideLoader();

					main.showMessageBox(data['text'], 'html');

					$('#rebirth-team').removeAttr('id').addClass('-color-cancel').removeClass('-color-yes');
				});
			});
		}
	};

	account.uiConnectNm1 = function()
	{
		$('#connect-nm1').on('click', clickConnectNm1Button);


		function clickConnectNm1Button()
		{
			if ($(this).hasClass('-color-cancel'))
				return false;

			var sendData = {
				'Nm1Username' : $('#input-nm1-username').val(),
				'Nm1Password' : $('#input-nm1-password').val()
			};

			main.showLoader('spin');

			$.ajaxHandler({
				url: '/ajax/connectNm1',
				type: 'POST',
				data: sendData,
				dataType: 'json',
				cache: false
			}).done(function(data)
			{
				main.hideLoader();

				main.showMessageBox(data['text'], 'html');
			});
		}
	};

	account.uiSettings = function()
	{
		$('#update-settings').on('click', clickUpdateSettingsButton);


		function clickUpdateSettingsButton()
		{
			if ($(this).hasClass('grey'))
				return false;

			var sendData = {
				//'LowQuality' : $('#input-lowquality').prop('checked') ? 1 : 0,
				'DisableGif' : $('#input-disablegif').prop('checked') ? 1 : 0,
				'Speed' : $('#input-speed').val(),
				'Pack' : $('#input-pack').val()
			};

			main.showLoader('spin');

			$.ajaxHandler({
				url: '/ajax/updateSettings',
				type: 'POST',
				data: sendData,
				dataType: 'json',
				cache: false
			}).done(function(data)
			{
				main.hideLoader();

				main.showMessageBox(data['text'], 'html');
			});
		}
	};

    account.zoomOutForm = function()
    {
        var viewportMeta = document.querySelector('meta[name="viewport"]');

        if (viewportMeta) {
            viewportMeta.setAttribute('content', 'width=device-width, maximum-scale=1.0, initial-scale=1.0');
        }
    };

}(window.account = window.account || {}, jQuery));

$(function()
{
    account.init();
});
